export const TITULO = 'Finalizar pagamento'

export const DESCRICAO = 'Por favor, informe o código de segurança (CVV) do seu cartão de crédito para efetuar o pagamento.'

export const FRASE_APOIO_CVV = 'Últimos três ou quatro números no verso do cartão.'
